import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
} from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";
import "moment/locale/he";
import DowloadFiles from "./DownloadFiles";
import Container from "@mui/material/Container";
import { RolesContext } from "../context/User";
import React from "react";
import { MoreVert } from "@mui/icons-material";
import LoadingBox from "./Loading";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import logger from "../utilitis/logger";

export default function ComponentList({ clicked, data, handleValueChange }) {
  const [invoice, setInvoice] = useState([]);
  const [expandedInfo, setExpandedInfo] = useState();
  const [expanded, setExpanded] = useState(null);
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const navigate = useNavigate();
  const [currentday, setCurrentday] = useState();
  const [text, setText] = useState("");
  const [alert, setAlert] = useState(false);
  const [circular, setcircular] = useState(false);
  const [snackbar, setSnackbar] = useState(false);

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#dfedf5",
      fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 15,
    },
  }));

  useEffect(() => {
    setInvoice(null);
    setExpanded(null);
    setcircular(false);
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const formattedDate = `${firstDayOfMonth.getFullYear()}-${String(
      firstDayOfMonth.getMonth() + 1
    ).padStart(2, "0")}-${String(firstDayOfMonth.getDate()).padStart(2, "0")}`;
    setCurrentday(formattedDate);
    async function fetchData() {
      try {
        const response = await axios.post(
          "invoicesAndReceipts/viewInvoicesAndReceipts",
          {
            withCredentials: true,
            cust_id: stateroles.userId,
            fromdate: data ? data.fromdate : formattedDate,
            todate: data
              ? data.todate
              : `${currentDate.getFullYear()}-${String(
                  currentDate.getMonth() + 1
                ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
                  2,
                  "0"
                )}`,
            type: data ? data.type : "I",
            skip: 0,
            ivnum: data ? data.ivnum : null,
          }
        );
        if (response.status == 200) {
          setInvoice(response.data);
        }
      } catch (error) {
        if (error.response.status == 400 || error.response.status == 500) {
          navigate(`/errormessage`);
        } else if (error.response.status == 403) {
          navigate(`/`);
        } else if (error.response.status == 404) {
          setInvoice([
            {
              IVNUM: ` לא נמצאו נתונים בין תאריכים ${
                data
                  ? moment(data.fromdate).format("L")
                  : moment(formattedDate).format("L")
              } ל- ${
                data
                  ? moment(data.todate).format("L")
                  : moment(
                      `${currentDate.getFullYear()}-${String(
                        currentDate.getMonth() + 1
                      ).padStart(2, "0")}-${String(
                        currentDate.getDate()
                      ).padStart(2, "0")}`
                    ).format("L")
              }`,
              IVDATE: null,
              TYPE: null,
              TOTPRICE: null,
              ERROR: true,
            },
          ]);
        }
      }
    }
    fetchData();
    handleValueChange(false);
  }, [clicked]);

  const expandMore = async (ivnum, type, index) => {
    setcircular(index);
    setAlert(false);
    setText("");
    if (expanded != index) {
      try {
        const response = await axios.post(
          `invoicesAndReceipts/getDetailsInvoice`,
          {
            withCredentials: true,
            type: type,
            ivnum: ivnum,
          }
        );
        setExpandedInfo(response.data);
        setExpanded(expanded === index ? null : index);
        setcircular(circular === index ? null : index);
      } catch (error) {
        if (error.response.status == 400) {
          setAlert(true);
          setText("התקבלה שגיאה בהצגת נתונים");
          setTimeout(() => {
            setAlert(false);
            setText("");
          }, 10000);
          setcircular(null);
        } else if (error.response.status == 403) {
          navigate("/");
        }

        logger.error(error);
      }
    }
    setExpanded(expanded === index ? null : index);
    setcircular(circular === index ? null : index);
  };

  return (
    <Container maxWidth="xl">
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={alert ? true : false}
        autoHideDuration={6000}
        key={"AlertSnapbar"}
      >
        <Alert
          sx={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}
          severity="warning"
        >
          {text}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "none", md: "flex" },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {invoice ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">תאריך</StyledTableCell>
                  <StyledTableCell align="center">מספר חשבונית</StyledTableCell>
                  <StyledTableCell align="center">סוג חשבונית</StyledTableCell>
                  <StyledTableCell align="center">סכום</StyledTableCell>
                  <StyledTableCell align="center">פרטים נוספים</StyledTableCell>
                  <StyledTableCell align="center"> </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice.map((component, index) => (
                  <React.Fragment key={index + "A"}>
                    <TableRow
                      key={index + "B"}
                      sx={{
                        backgroundColor:
                          expanded === index
                            ? "rgb(219, 217, 217)"
                            : "rgb(245,245,245)",
                      }}
                    >
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: expanded === index ? "bold" : null }}
                      >
                        {component.IVDATE
                          ? moment(component.IVDATE).format("L")
                          : null}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: expanded === index ? "bold" : null }}
                      >
                        {component.IVNUM ? component.IVNUM : null}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={{ fontWeight: expanded === index ? "bold" : null }}
                      >
                        {component.TYPE == "T"
                          ? "קבלה"
                          : component.DEBIT == "C"
                          ? "חש. זיכוי"
                          : component.TYPE == null
                          ? null
                          : "חשבונית"}
                      </StyledTableCell>
                      {component.TOTPRICE ? (
                        <StyledTableCell
                          align="center"
                          sx={{
                            fontWeight: expanded === index ? "bold" : null,
                          }}
                        >
                          <Typography variant="body2">
                            {`${parseFloat(
                              Math.abs(component.TOTPRICE)
                            ).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}${component.TOTPRICE < 0 ? "-" : ""} ${
                              component.CODE
                            }`}
                          </Typography>
                        </StyledTableCell>
                      ) : (
                        <TableCell align="center"></TableCell>
                      )}
                      {component.TOTPRICE ? (
                        <TableCell align="center">
                          <IconButton
                            onClick={() =>
                              expandMore(component.IVNUM, component.TYPE, index)
                            }
                          >
                            {expanded === index ? (
                              <ExpandLessIcon />
                            ) : (
                              <>
                                <ExpandMoreIcon />
                                <Typography>
                                  {circular === index ? "נתונים נטענים..." : ""}
                                </Typography>
                              </>
                            )}
                          </IconButton>
                        </TableCell>
                      ) : (
                        <TableCell align="center"></TableCell>
                      )}
                      <TableCell align="center">
                        {component.ERROR ? null : (
                          <DowloadFiles
                            ivnum={component.IVNUM}
                            name={"הורדה"}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                    {expanded === index ? (
                      <>
                        <>
                          {component.TYPE == "T" ? (
                            <TableRow>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  חשבונית
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  סכום
                                </Typography>
                              </StyledTableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  מק"ט
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  תיאור מוצר
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  כמות
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  מחיר ליחידה
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  סה"כ מחיר
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Typography
                                  variant="caption"
                                  sx={{
                                    fontWeight: "bold",
                                  }}
                                >
                                  סה"כ מחיר כלל מע"מ
                                </Typography>
                              </StyledTableCell>
                            </TableRow>
                          )}
                          {expandedInfo.map((item, index) => (
                            <TableRow key={index}>
                              <StyledTableCell align="center" colSpan={1}>
                                <Typography variant="body2">
                                  {component.TYPE == "T"
                                    ? item.FNCIREF1
                                    : item.PARTNAME}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell align="center" colSpan={1}>
                                <Typography variant="body2">
                                  {component.TYPE === "T"
                                    ? `${parseFloat(
                                        Math.abs(item.CREDIT)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}${item.CREDIT < 0 ? "-" : ""} 
                                     ${component.CODE} `
                                    : item.PDES}
                                </Typography>
                              </StyledTableCell>
                              {component.TYPE != "T" ? (
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {item.TQUANT}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {component.TYPE != "T" ? (
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {`${parseFloat(
                                      Math.abs(item.PRICE)
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}{" "}
                                    {item.CODE}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {component.TYPE != "T" ? (
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {`${parseFloat(
                                      Math.abs(item.QPRICE)
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`}{" "}
                                    {item.CODE}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {component.TYPE != "T" ? (
                                <StyledTableCell align="center" colSpan={1}>
                                  <Typography variant="body2">
                                    {`${parseFloat(
                                      item.TOTPRICE
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })} ${item.CODE}`}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                            </TableRow>
                          ))}
                        </>
                      </>
                    ) : null}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <LoadingBox />
        )}
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: { xs: "flex", md: "none" },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {invoice ? (
          <Grid container spacing={2} sx={{ marginBottom: "2rem" }}>
            {invoice &&
              invoice.map((component, index) => (
                <Grid item xs={12} key={index}>
                  <Card
                    sx={{
                      backgroundColor:
                        expanded === index ? "rgb(219, 217, 217)" : null,
                    }}
                  >
                    <CardContent
                      sx={{ padding: 0, paddingBottom: "0 !important" }}
                    >
                      <Grid container alignItems="center">
                        <Grid item xs={!component.ERROR ? 5 : 12}>
                          <Typography align="center" variant="body2">
                            {component.IVNUM ? component.IVNUM : null}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography align="center" variant="body2">
                            {component.IVDATE
                              ? moment(component.IVDATE).format("L")
                              : null}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          {!component.ERROR ? (
                            <DowloadFiles
                              ivnum={component.IVNUM}
                              name={""}
                              style={"none"}
                            />
                          ) : null}
                        </Grid>
                        <Grid item xs={5}>
                          <Typography variant="body2" align="center">
                            {component.TYPE == "T"
                              ? "קבלה"
                              : component.DEBIT == "C"
                              ? "חש. זיכוי"
                              : component.TYPE == null
                              ? null
                              : "חשבונית"}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography align="center" variant="body2">
                            {component.TOTPRICE
                              ? `${parseFloat(
                                  Math.abs(component.TOTPRICE)
                                ).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}${component.TOTPRICE < 0 ? "-" : ""} ${
                                  component.CODE
                                }`
                              : null}
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          {!component.ERROR ? (
                            <IconButton
                              sx={{ marginLeft: "0.4rem" }}
                              onClick={() =>
                                expandMore(
                                  component.IVNUM,
                                  component.TYPE,
                                  index
                                )
                              }
                            >
                              <ExpandMoreIcon />
                            </IconButton>
                          ) : null}
                        </Grid>
                      </Grid>
                    </CardContent>
                    {expanded === index ? (
                      <CardContent>
                        {component.TYPE == "T" ? (
                          <>
                            {expandedInfo.map((item, index) => (
                              <>
                                <Divider variant="middle" />
                                <Grid
                                  key={index}
                                  container
                                  alignItems="center"
                                  sx={{
                                    marginTop: "1rem",
                                    marginBottom: "1rem",
                                  }}
                                >
                                  <Grid item xs={5}>
                                    <Typography align="left" variant="body2">
                                      מס': {item.FNCIREF1}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Typography
                                      align="center"
                                      variant="body2"
                                    ></Typography>
                                  </Grid>
                                  <Grid item xs={5}>
                                    <Typography align="left" variant="body2">
                                      סכום:
                                      <br />
                                      {`${parseFloat(
                                        Math.abs(item.CREDIT)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}${item.CREDIT < 0 ? "-" : ""} 
                                     ${component.CODE} `}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            ))}
                          </>
                        ) : (
                          <>
                            {expandedInfo.map((item, index) => (
                              <>
                                <Divider variant="middle" />
                                <Grid
                                  key={index}
                                  container
                                  alignItems="center"
                                  sx={{
                                    marginTop: "1rem",
                                    marginBottom: "1rem",
                                  }}
                                >
                                  <Grid item xs={5}>
                                    <Typography align="left" variant="body2">
                                      מק"ט: {item.PARTNAME}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Typography
                                      align="center"
                                      variant="body2"
                                    ></Typography>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography align="left" variant="body2">
                                      תיאור מוצר: {item.PDES}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography align="left" variant="body2">
                                      כמות: {item.TQUANT}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography align="left" variant="body2">
                                      מחיר ליחידה:
                                      {`${parseFloat(
                                        Math.abs(item.PRICE)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}{" "}
                                      {item.CODE}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography align="left" variant="body2">
                                      סה"כ מחיר:{" "}
                                      {`${parseFloat(
                                        Math.abs(item.QPRICE)
                                      ).toLocaleString("en-US", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}{" "}
                                      {item.CODE}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            ))}
                          </>
                        )}
                      </CardContent>
                    ) : null}
                  </Card>
                </Grid>
              ))}
          </Grid>
        ) : (
          <LoadingBox />
        )}
      </Box>
    </Container>
  );
}
